// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"41db1bcf","197":"99410ae7","623":"e53d5f63","812":"c451229f","863":"c0eb470c","939":"6c660c65"}[chunkId] + ".chunk.js";
};